import {
    GET_MY_SLACK_WORKSPACES,
    GET_SLACK_WORKSPACE_USERS,
    CLEAR_SLACK_WORKSPACE_USERS,
    CREATE_SLACK_TASK,
    GET_SLACK_TASK_HISTORY,
    GET_SLACK_MY_TASK_HISTORY,
    CLEAR_SLACK_TASK_HISTORY,
    GET_SLACK_DAILY_DIGEST,
    GET_SLACK_MY_DAILY_DIGEST,
    CLEAR_SLACK_DAILY_DIGEST,
    GET_SLACK_WORKSPACE_TASKS,
    CLEAR_SLACK_WORKSPACE_TASKS,
    GET_SLACK_TASK_METRICS,
    CLEAR_SLACK_TASK_METRICS,
    GET_SLACK_MEETINGS,
    CLEAR_SLACK_MEETINGS,
    GET_SLACK_MEETING_TASKS,
    CLEAR_SLACK_MEETING_TASKS,
  } from "constants/actions";
  
  const initialState = {
    // My Workspaces
    myWorkspaces: [],
    currentWorkspaceId: null,
    myWorkspacesPending: false,
    
    // Workspace Users
    workspaceUsers: [],
    workspaceUsersPending: false,
    
    // Task Creation
    taskCreated: null,
    taskCreationPending: false,
    
    // Task History
    taskHistory: [],
    taskHistoryPending: false,
    myTaskHistory: [],
    myTaskHistoryPending: false,
    
    // Daily Digest
    dailyDigest: null,
    dailyDigestPending: false,
    myDailyDigest: null,
    myDailyDigestPending: false,
    
    // Workspace Tasks
    workspaceTasks: [],
    workspaceTasksPending: false,
    workspaceTasksTotal: 0,
    
    // Task Metrics
    taskMetrics: null,
    taskMetricsPending: false,
    
    // Meetings
    meetings: [],
    meetingsPending: false,
    meetingsTotal: 0,
    
    // Meeting Tasks
    meetingTasks: [],
    meetingTasksPending: false,
    
    // Common
    message: null,
    updated: false,
  };
  
  export default function slackTasksReducer(state = initialState, action) {
    switch (action.type) {
      // ==================== MY WORKSPACES ====================
      case GET_MY_SLACK_WORKSPACES:
        return {
          ...state,
          myWorkspaces: action.payload?.workspaces || [],
          currentWorkspaceId: action.payload?.workspaces?.[0]?.id || null,
          myWorkspacesPending: false,
          updated: true,
        };
      
      // ==================== WORKSPACE USERS ====================
      case GET_SLACK_WORKSPACE_USERS:
        return {
          ...state,
          workspaceUsers: action.payload?.users || action.payload || [],
          workspaceUsersPending: false,
          updated: true,
        };
      
      case CLEAR_SLACK_WORKSPACE_USERS:
        return {
          ...state,
          workspaceUsers: [],
          workspaceUsersPending: false,
        };
  
      // ==================== CREATE TASK ====================
      case CREATE_SLACK_TASK:
        return {
          ...state,
          taskCreated: action.payload,
          taskCreationPending: false,
          message: action.payload?.message || "Task created successfully",
          updated: true,
        };
  
      // ==================== TASK HISTORY ====================
      case GET_SLACK_TASK_HISTORY:
        return {
          ...state,
          taskHistory: action.payload || {},
          taskHistoryPending: false,
          updated: true,
        };
      
      case GET_SLACK_MY_TASK_HISTORY:
        return {
          ...state,
          myTaskHistory: action.payload || {},
          myTaskHistoryPending: false,
          updated: true,
        };
      
      case CLEAR_SLACK_TASK_HISTORY:
        return {
          ...state,
          taskHistory: [],
          myTaskHistory: [],
          taskHistoryPending: false,
          myTaskHistoryPending: false,
        };
  
      // ==================== DAILY DIGEST ====================
      case GET_SLACK_DAILY_DIGEST:
        return {
          ...state,
          dailyDigest: action.payload,
          dailyDigestPending: false,
          updated: true,
        };
      
      case GET_SLACK_MY_DAILY_DIGEST:
        return {
          ...state,
          myDailyDigest: action.payload,
          myDailyDigestPending: false,
          updated: true,
        };
      
      case CLEAR_SLACK_DAILY_DIGEST:
        return {
          ...state,
          dailyDigest: null,
          myDailyDigest: null,
          dailyDigestPending: false,
          myDailyDigestPending: false,
        };
  
      // ==================== WORKSPACE TASKS ====================
      case GET_SLACK_WORKSPACE_TASKS:
        return {
          ...state,
          workspaceTasks: action.payload?.tasks || action.payload?.results || action.payload || [],
          workspaceTasksTotal: action.payload?.pagination?.total || action.payload?.count || 0,
          workspaceTasksPending: false,
        };
      
      case CLEAR_SLACK_WORKSPACE_TASKS:
        return {
          ...state,
          workspaceTasks: [],
          workspaceTasksTotal: 0,
          workspaceTasksPending: false,
        };
  
      // ==================== TASK METRICS ====================
      case GET_SLACK_TASK_METRICS:
        return {
          ...state,
          taskMetrics: action.payload,
          taskMetricsPending: false,
          updated: true,
        };
      
      case CLEAR_SLACK_TASK_METRICS:
        return {
          ...state,
          taskMetrics: null,
          taskMetricsPending: false,
        };
  
      // ==================== MEETINGS ====================
      case GET_SLACK_MEETINGS:
        return {
          ...state,
          meetings: action.payload?.meetings || action.payload?.results || action.payload || [],
          meetingsTotal: action.payload?.pagination?.total || action.payload?.count || 0,
          meetingsPending: false,
          updated: true,
        };
      
      case CLEAR_SLACK_MEETINGS:
        return {
          ...state,
          meetings: [],
          meetingsTotal: 0,
          meetingsPending: false,
        };
  
      // ==================== MEETING TASKS ====================
      case GET_SLACK_MEETING_TASKS:
        return {
          ...state,
          meetingTasks: action.payload?.tasks || action.payload || [],
          meetingTasksPending: false,
          updated: true,
        };
      
      case CLEAR_SLACK_MEETING_TASKS:
        return {
          ...state,
          meetingTasks: [],
          meetingTasksPending: false,
        };
  
      default:
        return state;
    }
  }